import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Event, Identifiable, VideoConferenceCallLink } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  links: Identifiable<VideoConferenceCallLink>[];
  retrieveVideoConferenceCallLinks(
    request: Boundaries["retrieveVideoConferenceCallLinks"]["request"],
  ): void;
}

function useRetrieveVideoConferenceCallLinks(
  event: Identifiable<Event>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveVideoConferenceCallLinksRequestPending(event),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveVideoConferenceCallLinksRequestSuccess(event),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveVideoConferenceCallLinksRequestFailure(event),
    ),
    links: useSelector(() => selector.getVideoConferenceCallLinks(event)),
    retrieveVideoConferenceCallLinks: core.retrieveVideoConferenceCallLinks,
  };
}

export { useRetrieveVideoConferenceCallLinks };
